let user = require('../../../actions/user');
let utils = require('../../../actions/utils');
let redirect = require('../../../actions/redirect');
let error = require('../../../actions/error');
let cookie = require('../../../actions/cookie');

/**
 * Попытка восстановить access_token по refresh_token
 * @param {Array} actions
 * @return {Array}
 */
function refreshToken (actions = []) {
    return [
        user.checkRefreshCookie, {
            exist: [
                [
                    user.refreshToken, {
                        success: [
                            cookie.unsetSessionToken,
                            cookie.setSessionToken,
                            ...actions
                        ],
                        accessDenied: [
                            cookie.unsetSessionToken,
                            utils.set(['user', 'role'], 'unauthorized')
                        ],
                        invalidValidation: [
                            cookie.unsetSessionToken,
                            utils.set(['user', 'role'], 'unauthorized')
                        ],
                        error: [
                            utils.set(['user', 'role'], 'unauthorized')
                        ]
                    }
                ]
            ],
            notExist: [
                utils.set(['user', 'role'], 'unauthorized')
            ]
        }
    ];
}

module.exports = {
    /**
     * Базовая проверка на наличие прав пользователя.
     * Актуально для перехода по страницам.
     * @param {String} section
     * @param {Array} [actions=[]] - success access actions
     * @returns {Array}
     */
    access (section, actions = []) {
        return [
            user.checkPermissions(section), {
                allowed: [
                    ...actions
                ],
                denied: [
                    error.accessDenied('user.checkPermissions')
                ]
            }
        ];
    },

    /**
     * Проверка на авторизацию пользователя если токен протух то делаем восстановление, иначе устанавливаем
     * тип пользователя как неавторизованный
     * @param {Array} [actions=[]] - success access actions
     * @returns {Array}
     */
    checkAuthCookie (actions = []) {
        return [
            utils.isEqual(['bitrix', 'isBitrix'], true),
            {
                yes: [],
                no: [
                    [
                        user.checkAccessCookie,
                        {
                            exist: [
                                ...actions
                            ],
                            notExist: [
                                ...refreshToken(actions)
                            ]
                        }
                    ]
                ]
            }
        ];
    },

    /**
     * Получение данных по пользователю
     */
    getUser: [
        [
            user.getUser, {
                allowed: [
                    user.addUserRole,
                    utils.setFromArgsToState('extendedUser', 'user')
                ],
                401: [
                    ...refreshToken(
                        [
                            [
                                user.getUser, {
                                    allowed: [
                                        user.addUserRole,
                                        utils.setFromArgsToState('extendedUser', 'user')
                                    ],
                                    401: [
                                        utils.set(['user', 'role'], 'unauthorized')
                                    ],
                                    403: [
                                        error.accessDenied('user.getUser inner')
                                    ],
                                    404: [
                                        redirect.redirect('/registration/extra')
                                    ],
                                    denied: [
                                        utils.set(['user', 'role'], 'unauthorized')
                                    ]
                                }
                            ]
                        ]
                    )
                ],
                403: [
                    error.accessDenied('user.getUser outer')
                ],
                404: [
                    redirect.redirect('/registration/extra')
                ],
                denied: [
                    utils.set(['user', 'role'], 'unauthorized')
                ]
            }
        ]
    ]
};



// WEBPACK FOOTER //
// ./signals/groups/user/index.js